import { auditService } from "@/services";
import { useQuery } from "@tanstack/react-query";
import { qk } from "./queryKeys";

export function useAudit(limit = 100) {
	return useQuery({
		queryKey: qk.audit,
		queryFn: ({ signal }) => auditService.list({ limit }, signal),
	});
}
